var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V112H496V16Z",
    fill: "#16A085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 112H16V208H496V112Z",
    fill: "#F1C40F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 208H16V304H496V208Z",
    fill: "#16A085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 304H16V400H496V304Z",
    fill: "#F1C40F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496 400H16V496H496V400Z",
    fill: "#16A085"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M236 16H16V304H236V16Z",
    fill: "#E32D3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M168.567 223.354L128.208 190.905L85.2797 224.325L103.669 175.914L58.6196 145.414L110.343 147.944L125.43 95.674L139.007 145.648L193.381 143.844L150.048 172.199L168.567 223.354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/TG.fd72f32e8e902e55b69c4df96c51be81.svg";
export { ForwardRef as ReactComponent };